











































































































import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import ApplicationForm from './ApplicationForm.vue'
import SparepartsTable from './SparepartsTable.vue'
import MaintenanceTable from './MaintenanceTable.vue'
import {
  MaintainItemServiceProxy,
  MaintainPlanServiceProxy,
  MaintainRecordServiceProxy
} from '@/service-proxies/app-v2/tpm.service-proxies'
import dayjs from 'dayjs'
import { CodeRuleServiceProxy } from '@/service-proxies/app-v2/code.service-proxies'
import { StockOutOrderMaterialServiceProxy } from '@/service-proxies/app-v2/wms.service-proxies'

const soomsp = new StockOutOrderMaterialServiceProxy()
const mpsp = new MaintainPlanServiceProxy()
const misp = new MaintainItemServiceProxy()
const mrsp = new MaintainRecordServiceProxy()
const csp = new CodeRuleServiceProxy()

export default Vue.extend({
  data() {
    return {
      recordCodeIdList: [],
      show: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 12 },
      form: this.$form.createForm(this),
      loading: false,
      selectedData: {},
      maintainPlanList: [],
      selectPlanCode: '',
      maintainPlanItemVoList: [],
      maintainItemList: [],
      changeMaintenanceList: [],
      changeSparepartsList: [],
      maintenanceList: [],
      checkRecord: {
        planCode: '',
        deviceCode: '',
        deviceName: '',
        deviceTypeName: '',
        codeRuleId: '',
        projectName: ''
      },
      fetching: false,
      materialKey: ''
    }
  },
  components: {
    ApplicationForm,
    SparepartsTable,
    MaintenanceTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    employeesList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    visible: {
      handler() {
        if (this.visible) {
          const maintainPlanSearchDTO: any = {
            deviceId: '',
            deviceTypeId: '',
            filterPlus: false,
            keyWord: this.searchKey,
            param: {}
          }
          mpsp.queryMaintainPlanListByStatus(3).then((res) => {
            this.maintainPlanList = res
          })
          misp.queryMaintainItemList('').then((res) => {
            this.maintainItemList = res
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    csp.list('MaintainRecordObject').then((res) => {
      this.recordCodeIdList = res
    })
  },
  methods: {
    handleChange(value) {
      const data = this.maintainPlanList.find((res) => res.id === value)
      console.log(data)
      if (data !== undefined) {
        this.selectedData = data
        this.maintenanceList = []
        this.changeMaintenanceList = []
        mpsp.getMaintainPlan(data.id).then((res) => {
          this.checkRecord.planCode = res.code
          this.checkRecord.projectName = res.projectName
          this.checkRecord.deviceCode = res.deviceCode
          this.checkRecord.deviceName = res.deviceName
          this.checkRecord.deviceTypeName = res.deviceTypeName
          res.maintainPlanItemVoList.forEach((item, index) => {
            const data = {
              key: index,
              id: item.itemId,
              code: item.itemCode,
              name: item.itemName,
              remark: item.itemRemark,
              requirement: item.itemRequirement,
              isExecute: true
            }
            this.maintenanceList.push(data)
            this.changeMaintenanceList.push(data)
          })
        })
        soomsp
          .getStockOutOrderMaterialListByTpmCodeAndTpmId(data.code, data.id)
          .then((res) => {
            this.changeSparepartsList = res
          })
      } else {
        this.changeSparepartsList = []
        this.selectedData = {}
      }
    },
    changeCode(value) {
      this.selectPlanCode = value.target.value
    },
    changeRecord(val) {
      this.checkRecord.codeRuleId = val
      if (val) {
        this.form.setFieldsValue({ recordCode: '' })
        this.show = true
      } else {
        this.show = false
      }
    },
    close() {
      this.reset()
      this.$emit('close')
    },
    changeMaintenance(value) {
      this.changeMaintenanceList = value
    },
    changeSpareparts(value) {
      this.changeSparepartsList = value
    },
    reset() {
      this.form.resetFields()
      this.$refs.form1.form.resetFields()
      this.changeMaintenanceList = []
      this.changeSparepartsList = []
      this.selectedData = {}
    },
    save() {
      this.form.validateFields((err, valued) => {
        if (!err) {
          this.$refs.form1.form.validateFields((err, values) => {
            if (!err) {
              if (this.changeSparepartsList && this.changeSparepartsList.length) {
                let hasNum = true
                this.changeSparepartsList.forEach((element) => {
                  if (element.stockOutNum == null || element.stockOutNum == 0) {
                    hasNum = false
                  }
                })
                if (!hasNum) {
                  this.$message.warning('请输入备品备件数量')
                  return
                }
              }
              values.recordCode = valued.recordCode
                ? valued.recordCode.replace(/\s*/g, '')
                : valued.recordCode
              values.planId = valued.planId
              values.startTime = values.startTime
                ? dayjs(values.startTime).format('YYYY-MM-DD HH:mm:ss')
                : values.startTime
              values.endTime = values.endTime
                ? dayjs(values.endTime).format('YYYY-MM-DD HH:mm:ss')
                : values.endTime
              this.changeMaintenanceList.forEach((element) => {
                element.isExecute = element.isExecute ? 1 : 0
              })
              values.maintainRecordItemAddDTOList = this.changeMaintenanceList
              values.repairRecordMaterialAddDTOList = this.changeSparepartsList
              const person = this.employeesList.find((res) => res.id === values.maintainUserId)
              if (person !== undefined) {
                values.maintainUserName = person.name
              }
              const valueCheck = Object.assign(values, this.checkRecord)

              mrsp.createMaintainRecord(valueCheck).then(() => {
                this.$message.success(this.$t('create_success'))
                this.reset()
                this.$emit('reload')
              })
            }
          })
        }
      })
    }
  }
})
